import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { can, canFinance, canPayroll } from "@/lib/roles";
import Billing from "@/pages/admin/Billing";
import Expenses from "@/pages/admin/Expenses";
import Payroll from "@/pages/admin/Payroll";
import AdminStatements from "@/pages/admin/AdminStatements";

export default function Finance() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const finance = canFinance(user) && can(user, "billing");
  const expenses = canFinance(user) && can(user, "expenses");
  const statements = canFinance(user) && can(user, "tax_documents");
  const payroll = canPayroll(user) && can(user, "payroll");
  const allowed = [finance && "billing", expenses && "expenses", payroll && "payroll", statements && "statements"].filter(Boolean);
  const current = allowed.includes(params.get("tab")) ? params.get("tab") : allowed[0];

  return <div data-testid="finance-hub">
    <div className="mb-6"><p className="text-sm uppercase tracking-[0.2em] font-bold text-[#3B82F6]">Finance</p><h1 className="mt-3 text-4xl font-bold tracking-tight">Billing, expenses and payroll</h1><p className="mt-3 text-muted-foreground">Financial work is grouped here while each area keeps its own permissions.</p></div>
    <Tabs value={current} onValueChange={(tab) => setParams({ tab })}>
      <TabsList className="rounded-full mb-8">
        {finance && <TabsTrigger value="billing" className="rounded-full font-bold">Billing</TabsTrigger>}
        {expenses && <TabsTrigger value="expenses" className="rounded-full font-bold">Expenses</TabsTrigger>}
        {payroll && <TabsTrigger value="payroll" className="rounded-full font-bold">Payroll</TabsTrigger>}
        {statements && <TabsTrigger value="statements" className="rounded-full font-bold">Tax Statements</TabsTrigger>}
      </TabsList>
      {finance && <TabsContent value="billing"><Billing /></TabsContent>}
      {expenses && <TabsContent value="expenses"><Expenses /></TabsContent>}
      {payroll && <TabsContent value="payroll"><Payroll /></TabsContent>}
      {statements && <TabsContent value="statements"><AdminStatements /></TabsContent>}
    </Tabs>
  </div>;
}
